import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Landing.css';

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="logo">
          <h1> My Money - San Dev Code</h1>
        </div>
      </header>

      <main className="landing-main">
        <section className="hero">
          <h1 className="hero-title">
            Controle Financeiro Simples
            <br />
            para <span className="highlight">Freelancers e Pequenos Negócios</span>
          </h1>
          <p className="hero-subtitle">
            Gerencie seus lançamentos financeiros, calcule lucro real e tome decisões inteligentes
            com ajuda de IA.
          </p>
          <button className="cta-button" onClick={() => navigate('/login')}>
            Começar Agora - É Grátis
          </button>
        </section>

        <section className="features">
          <h2>Por que usar o My Money?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M3 3h18v4H3zM3 9h18v11H3z"/></svg></div>
              <h3>Controle de Lançamentos</h3>
              <p>Adicione serviços com valor cobrado e custos. Veja seu lucro real instantaneamente.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M3 3h18v18H3z"/></svg></div>
              <h3>Relatórios Inteligentes</h3>
              <p>Visualize faturamento, custos e lucro por período com gráficos interativos.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2 7h7l-5.5 4 2 7L12 16l-7.5 4 2-7L1 9h7z"/></svg></div>
              <h3>Sugestões com IA</h3>
              <p>Receba insights personalizados para otimizar seus preços e reduzir custos.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M2 6h20v4H2zM2 12h20v6H2z"/></svg></div>
              <h3>Plano Premium</h3>
              <p>Recursos ilimitados por apenas R$ 2,99/mês. Pague com PIX.</p>
            </div>
          </div>
        </section>

        <section className="how-it-works">
          <h2>Como funciona?</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Faça Login</h3>
              <p>Entre com sua conta Google de forma rápida e segura.</p>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <h3>Adicione Lançamentos</h3>
              <p>Registre seus serviços com valores e custos.</p>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <h3>Acompanhe Resultados</h3>
              <p>Veja relatórios e tome decisões baseadas em dados reais.</p>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <h2>Pronto para organizar suas finanças?</h2>
          <p>Comece agora mesmo. É grátis!</p>
          <button className="cta-button secondary" onClick={() => navigate('/login')}>
            Criar Conta Grátis
          </button>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; 2024 My Money - San Dev Code. Todos os direitos reservados.</p>
        <div className="footer-links">
          <a href="#termos">Termos de Uso</a>
          <a href="#privacidade">Política de Privacidade</a>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
